export const MORTAR_YPEAK = 7
export const TERRAIN_MESH_NAME = "Anianchak"
export const LEVELS_MODE = "auto"
export const GLTF_FILE = "anianchak.gltf"
export const MC_TABLE_XFORM = {
    pos: [-1.2,0,.1],
    scale: [1.88, 1.5,-1.88]
}
export const TABLE_BACKGROUND_ALPHA = 0.95;
export const MC_SCENE_CLEAR_COLOR = [0.38, 0.36, 0.41]

export const MC_NUM_LIGHTS = 1
export const MC_LIGHT1_POS = [0.2, 1, 0.2]
export const MC_LIGHT1_INTENSITY = 1
export const MC_LIGHT2_POS = [-1, 3.4, 4]
export const MC_LIGHT2_INTENSITY = 1
export const CHANGE_LIGHT_ON_BLAST = true

export const HAS_WATER = false

export const WATERBOX = {
    xMax: 12,
    xMin: -4,
    zMax: 8,
    zMin: -11.5
}
